<template>
  <d-modal
    class="crm-new-popup"
    :key="payment_key"
    v-if="showModal"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">
          Przyjęcie wpłaty
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <validation-observer
        ref="settlements-payment"
        tag="form">
        <div class="form-group">
          <label for="payment_typ">
            Rodzaj płatności:
          </label>
          <validation-provider
            name="payment_typ"
            rules="required|min_value:0"
            v-slot="{ errors }">
            <div :class="{ 'form-control': true, 'is-select': true }">
              <v-select
                class="ml-2 w-100"
                :options="paymentMethods"
                :reduce="payment => payment.id"
                v-model="data.payment_type"
                placeholder="Wybierz rodzaj"
                :searchable="false"
                label="name">
                <template
                  slot="option"
                  slot-scope="option">
                  <div class="d-center">
                    {{ option.name ? option.name : '' }}
                  </div>
                </template>
                <template
                  slot="selected-option"
                  slot-scope="option">
                  <div class="selected d-center">
                    {{ option.name ? option.name : '' }}
                  </div>
                </template>
              </v-select>
            </div>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div
          class="spinner-load"
          v-if="loading_customers">
          <div
            class="spinner-border spinner-border-sm crm-new-popup-spinner"
            role="status"></div>
        </div>
        <d-alert
          v-if="data.payment_type !== '' && !customers.length && !loading_customers"
          show
          theme="danger">
          <i class="material-icons">report_problem</i> Nie masz żadnych klientów do rozliczenia w tej formie
        </d-alert>
        <div v-if="data.payment_type !== '' && customers.length">
          <div class="form-group">
            <label for="payment_typ">
              Klient:
            </label>
            <validation-provider
              name="payment_typ"
              rules="required|min_value:0"
              v-slot="{ errors }">
              <div :class="{ 'form-control': true, 'is-select': true }">
                <v-select
                  class="ml-2 w-100"
                  :options="customers"
                  :reduce="customer => customer.id"
                  v-model="data.customer_id"
                  placeholder="Wybierz klienta"
                  :searchable="false"
                  label="name">
                  <template
                    slot="option"
                    slot-scope="option">
                    <div class="d-center">
                      {{ option.name ? option.name : '' }}
                    </div>
                  </template>
                  <template
                    slot="selected-option"
                    slot-scope="option">
                    <div class="selected d-center">
                      {{ option.name ? option.name : '' }}
                    </div>
                  </template>
                </v-select>
              </div>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
          <d-alert
            v-if="data.customer_id"
            :theme="data.dept !== 0 ? 'danger' : 'success'"
            show>
            <div
              class="form-group mt-3"
              style="font-size: 1.2rem">
              <span class="font-weight-light"> Zadłużenie klienta:</span> <span>{{data.dept !== 0 ? data.dept.toFixed(2) : 0}}</span> zł<br>
              <span class="font-weight-light"> Liczba nieopłaconych zamówień:</span> <span>{{data.depth_orders_count}}</span><br />
            </div>
          </d-alert>
          <div
            class="form-group"
            v-if="data.customer_id">
            <validation-provider
              :rules="'required'"
              name="invoice_date"
              v-slot="{ errors }">
              <label for="invoice_date">
                Data wpłaty:
              </label>
              <date-picker
                v-model="data.invoice_date"
                class="stronger-input"
                valueType="format"
                style="width: 100%"/>
            </validation-provider>
            <div
              class="invalid-feedback"
              style="display: block;"
              v-if="!data.invoice_date">
              To pole jest wymagane
            </div>
          </div>
          <div
            class="form-group"
            v-if="data.customer_id">
            <label for="payment_cash">
              Kwota:
            </label>
            <validation-provider
              name="price"
              rules="required|min_value:0"
              v-slot="{ errors }">
              <input
                :class="{
                  'form-control custom-input-new stronger-input': true,
                  'is-invalid': errors.length
                }"
                :step="0.01"
                :min="0.0"
                :state="errors.length ? 'invalid' : null"
                type="number"
                v-model="data.amount" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </div>
        <div class="popup-box-buttons">
          <d-button
            theme="success"
            class="text-nowrap"
            :class="{ 'isLoading' : form_submitting }"
            @click.prevent="validateForm">
            Potwierdź
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="clearData">
            Anuluj
          </d-button>
        </div>
      </validation-observer>
      <orders-form-payment-confirm
        :data-value="confirm_modal_data"
        :show-modal="confirm_modal_table"
        :customer="customer"
        :close-modal="closeConfirm"/>
    </d-modal-body>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import DatePicker from 'vue2-datepicker';
import Vue from 'vue';
import OrdersFormPaymentConfirm from '../../components/forms/orders/OrdersFormPaymentConfirm';
import PaymentMethods from '@/data/payments-methods.js';

export default {
  name: 'settlements-payment',
  components: {
    OrdersFormPaymentConfirm,
    DatePicker,
  },
  data () {
    return {
      data: {
        payment_type: '',
        depth_orders_count: '',
        invoice_date: '',
        amount: '',
        dept: '',
        customer_id: ''
      },
      payment_key: 0,
      loading_customers: false,
      confirm_modal_table: false,
      form_submitting: false,
      openAlert: false,
      customers: [],
      customer: [],
      confirm_modal_data: []
    };
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    refresh: {
      type: Function
    },
  },
  watch: {
    'data.payment_type': function (value) {
      if (value) {
        this.loadCustomersItems(value);
      }
    },
    'data.amount': function (value) {
      if (value) {
        if (value >= this.data.dept) {
          this.data.amount = this.data.dept;
        }
      }
    },
    'data.customer_id': function (value) {
      if (value) {
        for (let i = 0; i < this.customers.length; i++) {
          if (this.customers[i].id === this.data.customer_id) {
            this.data.depth_orders_count = this.customers[i].depth_orders_count;
            this.data.dept = this.customers[i].dept;
            this.customer = this.customers[i];
          }
        }
      }
    }
  },
  computed: {
    paymentMethods () {
      return PaymentMethods;
    },
  },
  mounted () {
    this.getTime();
  },
  methods: {
    closeConfirm () {
      this.confirm_modal_table = false;
      this.confirm_modal_data = [];
      this.closeModal();
    },
    getTime () {
      const now = new Date();
      let date = [now.getFullYear(), now.getMonth() + 1, now.getDate()].map(num => (num < 10 ? '0' + num : num)).join('-');
      this.data.invoice_date = date.toString();
    },
    loadCustomersItems (value) {
      this.loading_customers = true;
      let $this = this;
      let where = {
        settlement_method: value,
        orders_in_dept: 1
      };
      FormUtils.loadAdditionalData(this, {
        endpoint: '/customers/items',
        outputKey: 'customers',
        params: {
          where,
          pagination: false
        },
        successAction (response) {
          $this.loading_customers = false;
          if (response.length) {
            $this.openAlert = false;
          }
          if (!response.length) {
            $this.openAlert = true;
          }
        }
      });
    },
    clearData () {
      this.closeModal();
    },
    validateForm () {
      FormUtils.validate(this.$refs['settlements-payment'], this.submitForm);
    },
    submitForm () {
      this.form_submitting = true;
      let formDataToSend = {
        amount: this.data.amount,
        payment_date: this.data.invoice_date,
        settlement_method: this.data.payment_type,
      };
      this.$http.post('/customers/add-payment/' + this.data.customer_id, formDataToSend).then((data) => {
        this.confirm_modal_table = true;
        this.confirm_modal_data = data.data.payments;
        this.form_submitting = false;
      }).catch((error) => {
        console.error(error);
        Vue.swal({
          title: 'Modyfikacja płatności nie powiodła się. Spróbuj ponownie.',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        this.form_submitting = false;
      });
    },
  }
};
</script>
